import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/layout/Navbar";
import Footer from "../../components/layout/Footer";
import "../../components/styles/contentRatingPage.scss";

/**
 * ContentRatingPage — MangoTV Content Rating Settings
 * Figma: Content Rating selection
 *
 * Layout:
 *   - Navbar (fixed top)
 *   - Breadcrumb: "Parental control > Selly's account > Content rating"
 *   - Single card (neutral_900 bg, rounded_xl, padding 32px)
 *   - Title: "Content rating"
 *   - 5 rating rows with radio-style checkboxes
 *   - "Save change" button at bottom
 *   - Footer below
 */

const ContentRatingPage = () => {
  const navigate = useNavigate();
  const [selectedRating, setSelectedRating] = useState("G");

  const handleSave = () => {
    // TODO: API call to save content rating
  };

  const ratings = [
    {
      id: "G",
      title: "G (General Audience)",
      description: "This is very suitable for all ages. No harmful or inappropriate content.",
    },
    {
      id: "PG",
      title: "PG (Parental Guidance)",
      description: "It may contain some material that is not suitable for children under 10 years of age. Parents are advised to provide guidance",
    },
    {
      id: "PG-13",
      title: "PG-13 (Parents Strongly Cautioned)",
      description: "May contain material not suitable for children under 13 years of age. Parents are advised to exercise caution and consider whether this film is suitable for their children",
    },
    {
      id: "R",
      title: "R (Restricted)",
      description: "Children under the age of 17 must be accompanied by a parent or guardian to watch this film. Content may include violence, strong language, or destructive material.",
    },
    {
      id: "NC-17",
      title: "NC-17 (Adults Only)",
      description: "Not allowed for children under 17 years of age. This film may contain sexually explicit content or very intense violence.",
    },
  ];

  return (
    <div className="content-rating-page">
      {/* Navbar */}
      <Navbar activeTab="Settings" />

      {/* Main Content */}
      <div className="content-rating-page__container">
        {/* Breadcrumb */}
        <div className="content-rating-page__breadcrumb">
          <span className="content-rating-page__breadcrumb-link" onClick={() => navigate("/settings/parental")} style={{ cursor: "pointer" }}>Parental control</span>
          <span className="content-rating-page__breadcrumb-separator">/</span>
          <span className="content-rating-page__breadcrumb-link" onClick={() => navigate("/settings/parental/selly")} style={{ cursor: "pointer" }}>Selly's account</span>
          <span className="content-rating-page__breadcrumb-separator">/</span>
          <span className="content-rating-page__breadcrumb-current">Content rating</span>
        </div>

        {/* Settings Card */}
        <div className="content-rating-page__card">
          <h1 className="content-rating-page__title">Content rating</h1>

          {/* Rating Items */}
          <div className="content-rating-page__items">
            {ratings.map((rating, index) => (
              <div
                key={rating.id}
                className={`content-rating-page__row ${
                  index < ratings.length - 1 ? "content-rating-page__row--border" : ""
                }`}
              >
                {/* Left: Title and Description */}
                <div className="content-rating-page__content">
                  <h3 className="content-rating-page__item-title">{rating.title}</h3>
                  <p className="content-rating-page__item-description">
                    {rating.description}
                  </p>
                </div>

                {/* Right: Radio Checkbox */}
                <div className="content-rating-page__checkbox-wrapper">
                  <input
                    type="radio"
                    name="content-rating"
                    className="content-rating-page__checkbox"
                    checked={selectedRating === rating.id}
                    onChange={() => setSelectedRating(rating.id)}
                    id={`rating-${rating.id}`}
                  />
                </div>
              </div>
            ))}
          </div>

          {/* Save Button */}
          <div className="content-rating-page__actions">
            <button
              className="content-rating-page__btn content-rating-page__btn--outline"
              onClick={handleSave}
            >
              Save change
            </button>
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default ContentRatingPage;
